/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { fetchHelpdeskPhoneNumbers } from '../../actions/actions';
import HelpdeskComponent from './helpdesk.component';

export const mapStateToProps = (state, ownProps) => {
  return {
    isFetching: state.helpdesk.isFetching,
    allPhoneNumbers: state.helpdesk.allPhoneNumbers
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadHelpdeskPhoneNumbers: () => {
      dispatch(fetchHelpdeskPhoneNumbers());
    }
  };
};

const HelpdeskContainer = connect(mapStateToProps, mapDispatchToProps)(HelpdeskComponent);

export default HelpdeskContainer;
